import _ from 'lodash'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import {
  getSubStationId,
  getProductName,
  getShipTypeId,
  getCatItemId,
  getAttrClusterId,
  getStruDataAttrCluster,
  getProposalListingFormValue,
  getShowExpiringAddon,
  selectFormError
} from '../../../../lib/ReduxFormSelectors/ProposalListingForm'
import { getAttrTransientKey } from '../ProposalForm/Shared/util'

const proposalListingFormSelectors = [
  getSubStationId,
  getProductName,
  // 在 shipType200 + model150 時會轉換成電子票券 shipType200150
  state => getShipTypeId(state, true),
  getCatItemId,
  getShowExpiringAddon,
  getAttrClusterId,
  getStruDataAttrCluster
]

const callback = (
  subStationId,
  productName,
  shipTypeId,
  catItemId,
  showExpiringAddon,
  struDataAttrClusterId,
  struDataAttrCluster
) => ({
  subStationId,
  productName,
  shipTypeId,
  catItemId,
  showExpiringAddon,
  struDataAttrClusterId,
  struDataAttrCluster,
  transientFieldReady: !!((subStationId && catItemId && struDataAttrClusterId)),
  transientField: `${getAttrTransientKey(subStationId, catItemId, struDataAttrClusterId)}`
})

/** 取 proposalListingForm 的某些欄位 value 傳進 specSettingForm */
const attributeCacheSelector = state => {
  // const formKey = Object.keys(state.form)[0]
  const reselect = createSelector(
    proposalListingFormSelectors,
    callback
  )

  return reselect(state)
}

const mapStateToProps = state => {
  const attrCacheObject = attributeCacheSelector(state)
  const {
    transientField,
    transientFieldReady
  } = attrCacheObject

  const transientModel = transientFieldReady
    ? (getProposalListingFormValue(state)(transientField) || {})
    : {}

  const transientErrors = _.get(selectFormError(state), transientField, {})

  const passingDownProps = {
    ...attrCacheObject,
    transientErrors,
    transientModel
  }

  return passingDownProps
}

const withAttributeTransient = connectedComponent => connect(mapStateToProps)(connectedComponent)

export default withAttributeTransient
